import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import StudentTransformation from './components/StudentTransformation';
import AboutCourse from './components/AboutCourse';
import CourseContent from './components/CourseContent';
import Gallery from './components/Gallery';
import Bonuses from './components/Bonuses';
import InvestmentRecovery from './components/InvestmentRecovery';
import TargetAudience from './components/TargetAudience';
import CountdownOffer from './components/CountdownOffer';
import Instructor from './components/Instructor';
import Certificate from './components/Certificate';
import Guarantee from './components/Guarantee';
import FAQ from './components/FAQ';
import Checkout from './components/Checkout';
import Footer from './components/Footer';
import LeadCapture from './components/LeadCapture';

function LandingPage() {
  return (
    <>
      <Header />
      <Hero />
      <StudentTransformation />
      <AboutCourse />
      <CourseContent />
      <Gallery />
      <Bonuses />
      <InvestmentRecovery />
      <TargetAudience />
      <CountdownOffer />
      <Instructor />
      <Certificate />
      <Guarantee />
      <FAQ />
      <Checkout />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/captura" element={<LeadCapture />} />
      </Routes>
    </div>
  );
}

export default App;
